import { Component, Input, OnInit } from '@angular/core';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';

@Component({
    standalone: false,
    selector: 'app-garbage-collector-sheduler-settings-form',
    templateUrl: './garbage-collector-sheduler-settings-form.component.html',
    styleUrls: ['./garbage-collector-sheduler-settings-form.component.scss']
})
export class GarbageCollectorShedulerSettingsFormComponent implements OnInit {
    _settings: ISchedulerSettings;

    formGroup: FormGroup;

    turnOnSchedulerControl = new FormControl(false);

    minGarbageCollectorSchedulerIntervalMin = 1;
    maxGarbageCollectorSchedulerIntervalMin = 7 * 24 * 60;

    garbageCollectorSchedulerIntervalMinControl = new FormControl(1, [
        Validators.required,
        Validators.min(this.minGarbageCollectorSchedulerIntervalMin),
        Validators.max(this.maxGarbageCollectorSchedulerIntervalMin),
        Validators.pattern('^[0-9]*$')
    ]);

    get settings(): ISchedulerSettings {
        return this._settings;
    }

    @Input()
    set settings(value: ISchedulerSettings) {
        this._settings = value;
        this.setFormData(this._settings);
    }

    constructor(
        protected readonly formBuilder: FormBuilder,
        protected readonly schedulerSettingsService: SchedulerSettingsService
    ) {
        this.formGroup = formBuilder.group({
            isGarbageCollectorSchedulerActive: this.turnOnSchedulerControl,
            garbageCollectorSchedulerIntervalMin: this.garbageCollectorSchedulerIntervalMinControl
        });
    }

    ngOnInit(): void {}

    setFormData(scheduleSettings: ISchedulerSettings) {
        if (!scheduleSettings) {
            return;
        }
        this.formGroup.patchValue(scheduleSettings);
    }
}
